import { IsOptional, Length } from 'class-validator';

import { PublicProfileTypeEnum } from '@onArte/shared/database/enums';

export class PublicProfileCreateModel {
  @Length(2, 64)
  public type: PublicProfileTypeEnum;

  @Length(32, 36)
  public relationId: string;

  @Length(0, 350)
  public description: string;

  @Length(0, 2048)
  public bio: string;

  @Length(32, 36, { each: true })
  public attachments: string[];

  @IsOptional()
  @Length(2, 128)
  public name?: string;
}
